const WillscotLogo = require("../../logos/willscot-logo.png");
import SunsetLogo from "../../logos/QUIXOTE-logotype-White.png";
import RaptorLogo from "../../logos/Velociti-Logo.webp";
import VMACLogo from "../../logos/VMAC Logo.png";
import AirforceLogo from "../../logos/AirForce-Logo.png"
import styles from "./AppHeader.module.scss";

export default function AppHeader() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const customer = urlParams.get("customer");
  return (
    <div className={styles.headerStyleDark}>
      <img
       className={
        customer === "airforce" ? styles.logoAirforce : styles.logo
       }
        src={
          customer === "willscot"
            ? WillscotLogo
            : customer === "sunset"
            ? SunsetLogo
            : customer === "raptor"
            ? RaptorLogo
            : customer === "vmac"
            ? VMACLogo
            : customer === "airforce"
            ? AirforceLogo
            : ""
          }
      />

    </div>
  );
}
